import type { FC } from 'react';

import { CampaignDeviceType, CampaignGender, CampaignSubSource } from 'utils/constants/campaign';

import BlokoLink from 'bloko/blocks/link';

import AgeRange from 'components/CampaignCard/CampaignInfo/Targetings/AgeRange/AgeRange';
import DesktopShows from 'components/CampaignCard/CampaignInfo/Targetings/DesktopShows/DesktopShows';
import Gender from 'components/CampaignCard/CampaignInfo/Targetings/Gender/Gender';
import MobileShows from 'components/CampaignCard/CampaignInfo/Targetings/MobileShows/MobileShows';
import Professions from 'components/CampaignCard/CampaignInfo/Targetings/Professions/Professions';
import Regions from 'components/CampaignCard/CampaignInfo/Targetings/Regions/Regions';
import SocialShows from 'components/CampaignCard/CampaignInfo/Targetings/SocialShows/SocialShows';
import VacancyId from 'components/CampaignCard/CampaignInfo/Targetings/VacancyId/VacancyId';

import { CampaignAreas, CampaignVacancy } from 'store/models/dashboard';

import styles from 'components/CampaignCard/CampaignInfo/Targetings/Targetings.module.less';

interface TargetingsProps {
    age: number[];
    areas: CampaignAreas;
    deviceType: CampaignDeviceType;
    professionalRoles: string[];
    sex: CampaignGender;
    sources: CampaignSubSource[];
    vacancy: CampaignVacancy | null;
}

const Targetings: FC<TargetingsProps> = ({ age, areas, deviceType, professionalRoles, sex, sources, vacancy }) => (
    <div className={styles.wrapper}>
        {vacancy && (
            <>
                <BlokoLink href={`https://hh.ru/vacancy/${vacancy.vacancyId}`}>{vacancy.name}</BlokoLink>
                <VacancyId vacancyId={vacancy.vacancyId} />
            </>
        )}
        <Regions campaignAreas={areas} />
        <Professions professionalRoles={professionalRoles} />
        <Gender sex={sex} />
        <SocialShows sources={sources} />
        <MobileShows deviceType={deviceType} />
        <DesktopShows deviceType={deviceType} />
        <AgeRange age={age} />
    </div>
);

export default Targetings;
